<template>
	<form @submit.prevent="submit">
		<BaseFormComponent id="login_username" label="Username">
			<BaseInput
				v-model="credentials.username"
				id="login_username"
				ref="username"
			/>
		</BaseFormComponent>

		<BaseFormComponent id="login_password" label="Password">
			<BaseInput
				type="password"
				v-model="credentials.password"
				id="login_password"
				ref="password"
			/>
		</BaseFormComponent>

		<BaseFormButtons>
			<button type="submit" ref="button">Log in</button>
		</BaseFormButtons>
	</form>
</template>

<script>
import { getErrors } from '@/core/http'
import BaseFormComponent from '@/core/components/BaseFormComponent'
import BaseInput from '@/core/components/BaseInput'
import BaseFormButtons from '@/core/components/BaseFormButtons'
import auth from '@/modules/authentication/auth'

export default {
	name: 'LoginForm',
	components: {
		BaseFormButtons,
		BaseFormComponent,
		BaseInput,
	},
	emits: [
		'loginSuccess',
	],
	data() {
		return {
			credentials: {
				username: '',
				password: '',
			},
		};
	},
	mounted() {
		setTimeout(() => {
			if (this.credentials.username === '') {
				this.$refs.username.$el.focus();
			} else if (this.credentials.password === '') {
				this.$refs.password.$el.focus();
			} else {
				this.$refs.button.focus();
			}
		}, 500);
	},
	methods: {
		submit() {
			this.$flashMessage.removeAll();

			auth.login(this.credentials)
				.then(() => {
					this.$emit('loginSuccess');
				})
				.catch(response => {
					const errors = getErrors(response);

					errors.forEach((text) => {
						this.$flashMessage.show({
							type: 'error',
							text,
						});
					});
				})
			;
		},
	},
};
</script>
